import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {langRegister} from "../../services/langRegister";
import {marketRegister} from "../../services/marketRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class NoPage extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount() {
        window.scrollTo(0, 0);
    }

    _renderText(item) {
        return langRegister.get("no-page", item);
    }

    render() {
        return (
            <div>
                <HeaderSignupOne view={"no-page"} props={this.props}/>
                <div className={Styles.container}>
                    <div className={Styles.title}>
                        {this._renderText("item_1")}
                    </div>
                    <div className={Styles.subtitle}>
                        {this._renderText("item_2")}
                    </div>
                    <div onClick={() => this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang())} className={Styles.button}>
                        {this._renderText("item_3")}
                    </div>
                </div>
            </div>
        );
    }
}

export default NoPage;


// WEBPACK FOOTER //
// ./src/pages/no-page/component.js